import { FC } from "react";
import Modal from "components/Modal";
import { useEditUserNames } from "../model/useEditUserNames";
import { formStyles as styles } from "shared/ui";
import { NameInput } from "./NameInput";

interface Props {
  firstName: string | null;
  lastName: string | null;
  onClose: () => void;
}

export const EditUserNamesModal: FC<Props> = ({
  firstName,
  lastName,
  onClose,
}) => {
  const form = useEditUserNames({ firstName, lastName }, onClose);

  return (
    <Modal isOpen onClose={onClose} title="Edit Name">
      <form
        className={styles.form}
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          form.submit();
        }}
      >
        <NameInput
          field={form.firstName}
          placeholder="First Name"
          autoComplete="given-name"
          disabled={form.isSubmitting}
          autoFocus
        />
        <NameInput
          field={form.lastName}
          placeholder="Last Name"
          autoComplete="family-name"
          disabled={form.isSubmitting}
        />
        {form.serverError && <p className={styles.error}>{form.serverError}</p>}
        <button
          type="submit"
          className={styles.submitButton}
          disabled={!form.canSubmit}
        >
          {form.isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>
    </Modal>
  );
};
